export {
  copyToClipboard,
  getFileExtension,
  openInNewTab,
  scrollToElementById,
} from '@avanta/shared/utils/common';

export function generateSecurePassword(length = 12): string {
  const charset =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=[]{}|;:,.<>?';
  const randomValues = new Uint32Array(length);
  crypto.getRandomValues(randomValues);
  return Array.from(randomValues, v => charset[v % charset.length]).join('');
}
